export class FormUtils {
  static handleClearInput(value: string): string | null {
    return value === '' ? null : value;
  }
}